import Adjusted from './lists/Adjusted';
import Executed from './lists/Executed';
import Inspected from './lists/Inspected';
import Signed from './lists/Signed';

export default {
    namespaced: true,
    state: () => ({
        collection : "Documents.My.Inspected",
        status: null,
        searches: []
    }),
    mutations: {
        SET_COLLECTION (state, payload) {
            state.collection = payload;
        },
        SET_STATUS (state, payload) {
            state.status = payload;
        },
        PUSH_SEARCH (state, payload) {
            let searchExists = state.searches.find(x => x.collection == payload.collection);

            if (searchExists) {
                searchExists.value = payload.value;
            } else {
                state.searches.push(payload);
            }
        }
    },
    getters: {
        getCollection (state) {
            return state.collection;
        },
        getStatus (state) {
            return state.status;
        },
        getSearches (state) {
            return state.searches;
        }
    },
    modules: {
        adjustedlist: Adjusted,
        executedlist: Executed,
        inspectedlist: Inspected,
        signedlist: Signed
    }
}